import { SmartContractExpenseImportsKeyType } from '../../keys';

const smartContractExpenseImportsKeys: SmartContractExpenseImportsKeyType = {
  url: 'URL',
  status: 'Status',
  progress: 'Progress',
  smartContractExpenseImports: 'SC Expense Imports',
  importSmartContractExpenseImports: 'Import SC Expense Imports',
  rowCount: 'Row Count',
  errorMessage: 'Error Message',
  searchByKey: 'Search by Key',
  searchById: 'Search by ID',
  searchByStatus: 'Search by Status',
  smartContractId: 'SC ID',
  value: 'Value',
  errorBacktrace: 'Error Backtrace'
};

export default smartContractExpenseImportsKeys;
